import { createStore, getActionIds } from '../helpers/redux';
import Immutable from 'immutable';

import { ProjectActions } from '../actions/project';

const projectActions = getActionIds(ProjectActions);

const initialState = Immutable.fromJS({
  search: {
    elements: {
      results: [],
      loading: false,
      sortType: null,
    },
  },
});

export const search = createStore(initialState, {
  [projectActions.resetReducers]: (state, action) => {
    return initialState;
  },

  [projectActions.sortData]: (state, action) => {
    const sortType = action.sortType;

    let elements = state
      .getIn(['search', 'elements', 'results'])
      .sort((a, b) => {
        let lowerCaseA = a.get('name').toLowerCase();
        let lowerCaseB = b.get('name').toLowerCase();

        switch (sortType) {
          case 'ascending':
            if (lowerCaseA < lowerCaseB) {
              return -1;
            } else if (lowerCaseA > lowerCaseB) {
              return 1;
            } else {
              return 0;
            }
          case 'descending':
            if (lowerCaseA < lowerCaseB) {
              return 1;
            } else if (lowerCaseA > lowerCaseB) {
              return -1;
            } else {
              return 0;
            }
          case 'elementType':
            if (a.get('type_id') < b.get('type_id')) {
              return -1;
            } else if (a.get('type_id') > b.get('type_id')) {
              return 1;
            } else {
              return 0;
            }
          case 'date':
            if (a.get('created_at') > b.get('created_at')) {
              return -1;
            } else if (a.get('created_at') < b.get('created_at')) {
              return 1;
            } else {
              return 0;
            }
          default:
            return 0;
        }
      });

    return state.merge({
      search: {
        elements: {
          results: elements,
          sortType: sortType,
        },
      },
    });
  },

  [projectActions.clearSearch]: (state, action) => {
    return state.merge({
      search: {
        elements: {
          results: [],
          sortType: null,
        },
      },
    });
  },
});



// WEBPACK FOOTER //
// ./src/reducers/search.js